/**
 * This files consist of functions that return initial values for
 * NavbarDropdownMenu, NavbarDropdownMenuColumn and NavbarDropdownMenuItem.
 */
import {
  NavbarDropdownMenu,
  NavbarDropdownMenuColumn,
  NavbarDropdownMenuItem,
} from '@typedream/core';
import { v4 as uuidv4 } from 'uuid';

export const makeInitialMenuItemValue = (
  itemType?: NavbarDropdownMenuItem['itemType'],
): NavbarDropdownMenuItem => ({
  id: uuidv4(),
  type: 'navbar_dropdown_menu_item',
  itemType: itemType || 'short',
  title: 'Product Name',
  description: 'Type your product description in this space.',
  children: [{ id: uuidv4(), text: '' }],
});

export const makeInitialMenuColumnValue = (): NavbarDropdownMenuColumn => ({
  id: uuidv4(),
  type: 'navbar_dropdown_menu_column',
  children: [{ id: uuidv4(), text: '' }],
});

export const makeInitialMenuValue = (): NavbarDropdownMenu => ({
  id: uuidv4(),
  type: 'navbar_dropdown_menu',
  style: 'big-box',
  children: [makeInitialMenuColumnValue()],
});
